import React from 'react';
import {useTranslation} from "react-i18next";
import {Image} from "react-bootstrap";
import dashboardImage from "../../../assets/img/bimi-record-for-brand-trust.webp";
import {Card} from "../common/Card";


export const EnterpriseBIMI = () => {
    const {t} = useTranslation();

    return (
        <>
            <div className={"container "}>
                <div className="row align-items-center justify-content-between flex-column-reverse flex-lg-row py-5" id={"hero"}>
                    <div className="col px-4 mb-4 mb-lg-0 text-center text-lg-start">
                        <h1>{t("pages.enterpriseBimi.title")}</h1>
                        <div className="mb-3">
                            {t("pages.enterpriseBimi.description")}
                        </div>
                        <button className="btn btn-primary text-white">
        {t("pages.enterpriseBimi.cta")}
      </button>
                    </div>
                        <div className="col px-4 d-flex justify-content-center">
                        <div className="col-12 col-md-10 col-lg-8 d-flex align-items-center justify-content-center px-4">
                            <Image src={dashboardImage} alt={"dashboard"} className={"img-fluid"}></Image>
                        </div>

                    </div>
                </div>

                <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4 py-5 justify-content-center" id="cards">
                    <div className={"col"}>
                        <Card
                            title={t("pages.enterpriseBimi.cards.one.title")}
                            features={t("pages.enterpriseBimi.cards.one.features")}
                            iconClass={"bi bi-tv-fill text-primary"}
                        ></Card>
                    </div>
                    <div className={"col"}>
                        <Card
                            title={t("pages.enterpriseBimi.cards.two.title")}
                            features={t("pages.enterpriseBimi.cards.two.features")}
                            iconClass={"bi bi-tv-fill text-primary"}
                        ></Card>
                    </div>
                </div>
            </div>
        </>
    )
};
